import { Component, OnInit } from '@angular/core';
import { IndustriepartnerService } from 'src/app/core/services/interfaces/industriepartner.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AuthService } from 'src/app/core/services/auth.service';
import { User } from 'src/app/shared/model';

@Component({
    selector: 'app-nav-bar',
    templateUrl: './nav-bar.component.html',
    styleUrls: ['./nav-bar.component.scss'],
})
export class NavBarComponent implements OnInit {
    anbieterNr: number;

    user: User;
    isTest = false;

    constructor(
        private industriepartnerService: IndustriepartnerService,
        private snackbar: MatSnackBar,
        private auth: AuthService
    ) {}

    ngOnInit() {
        this.auth.currentUser.subscribe(user => {
            this.user = user;
            this.isTest = sessionStorage.getItem('test') == 'true';
        });
    }

    setAnbieterNr() {
        this.industriepartnerService.setAnbieterNr(this.anbieterNr);
        this.snackbar.open(`Eingewählt als ${this.anbieterNr}`, 'OK');
    }

    getAnbieterNr() {
        return this.industriepartnerService.getAnbieterNr();
    }
}
